import req from 'shared/req';
import {CurrentInstitution} from 'src/types/education';

export interface PendingEducator {
  _id: string;
  connectionCount: number;
  email: string;
  firstName: string;
  lastName: string;
  institution: CurrentInstitution;
  isRejected: boolean | null;
  isVerified: boolean | null;
  linkedinProfile?: string;
  officialIdUrl: string;
  onboardingCompletedAt: string;
  type: string;
  websiteForEmployment: string;
  createdAt: number;
  emailVerifiedAt: number;
}

interface RejectionDetails {
  reason: string;
  linkedin: boolean;
  photo: boolean;
  avatar: boolean;
}

export default class EducatorVerificationService {
  static async index(): Promise<PendingEducator[]> {
    let response: PendingEducator[];
    try {
      response = await req<PendingEducator[]>({
        url: '/v1/educator-verification',
        method: 'GET',
      });
    } catch (err) {
      console.log(err);
      throw new Error();
    }

    return response;
  }

  static async show(email: string): Promise<PendingEducator> {
    try {
      return await req<PendingEducator>({
        url: `/v1/educator-verification/inspect?email=${encodeURIComponent(email)}`,
        method: 'GET',
      });
    } catch (err) {
      console.log(err);
      throw new Error();
    }
  }

  static async verify(id: string): Promise<PendingEducator> {
    let response: PendingEducator;
    try {
      response = await req<PendingEducator>({
        url: '/v1/educator-verification/verify',
        method: 'POST',
        data: {_id: id},
      });
    } catch (err) {
      console.log(err);
      throw new Error();
    }

    return response;
  }

  static async reject(id: string, details: RejectionDetails): Promise<PendingEducator> {
    let response: PendingEducator;
    try {
      response = await req<PendingEducator>({
        url: '/v1/educator-verification/reject',
        method: 'POST',
        data: {_id: id, details},
      });
    } catch (err) {
      console.log(err);
      throw new Error();
    }

    return response;
  }
}
